import { BigQueryEventName } from './bigQuery.types';

export const IDENTIFICATION_EMBEDDED_PROPERTIES = {
    group: 'identification flow',
} as const;

export type EventsWithEmbeddedProperties = Exclude<
    BigQueryEventName,
    'apple_click' | 'facebook_click' | 'google_click'
>;

export const BIGQUERY_EMBEDDED_PROPERTIES: Record<
    EventsWithEmbeddedProperties,
    typeof IDENTIFICATION_EMBEDDED_PROPERTIES
> = {
    'identification.show': IDENTIFICATION_EMBEDDED_PROPERTIES,
    'identification.back': IDENTIFICATION_EMBEDDED_PROPERTIES,
    'identification.failed': IDENTIFICATION_EMBEDDED_PROPERTIES,
    'identification.completed': IDENTIFICATION_EMBEDDED_PROPERTIES,
    'identification.initial.show': IDENTIFICATION_EMBEDDED_PROPERTIES,
    'identification.initial.email_click': IDENTIFICATION_EMBEDDED_PROPERTIES,
    'identification.email_identification.show': IDENTIFICATION_EMBEDDED_PROPERTIES,
    'identification.email_identification.continue': IDENTIFICATION_EMBEDDED_PROPERTIES,
    'identification.email_identification.show_password': IDENTIFICATION_EMBEDDED_PROPERTIES,
    'identification.email_identification.hide_password': IDENTIFICATION_EMBEDDED_PROPERTIES,
    'identification.reset_password_change.show': IDENTIFICATION_EMBEDDED_PROPERTIES,
    'identification.reset_password_change.submit': IDENTIFICATION_EMBEDDED_PROPERTIES,
    'identification.reset_password_change.completed': IDENTIFICATION_EMBEDDED_PROPERTIES,
    'identification.reset_password_change.failed': IDENTIFICATION_EMBEDDED_PROPERTIES,
    'identification.profile_setup.show': IDENTIFICATION_EMBEDDED_PROPERTIES,
    'identification.profile_setup.submit': IDENTIFICATION_EMBEDDED_PROPERTIES,
};
